import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import {showhidediv,loadwidgate,clrwidgate,gtdfltvid,setdvl,openemoji,configchat,getsid,setlogininfo,getloginuser,hdactinf,Exituser,gtpblvl,changeback,chngbackbyid,
insertpost,scrolldowncboat,runtimerchatmsg,entervilla,setusersinactiondv,hideemoji,showemoji} from './userdefaultdata';
import {cleardv} from './clearmem';
import Villactions from './Villactions';
import Userpfp from './Userpfp';
import {Chtuser} from './Userchat';
import EmojiPickercomp from './Emoji';
import {Userpmusers,pvtmus} from './Userpmgs';
import notif from './imgs/blb1.gif';
import notifsrv from './imgs/notifysrv.png';
import msgbox from './imgs/posting.png';
import { getmessage} from './Dynamictable';
import ReceiverPublicvilla from './socketpublicvilla';

export default class Cthmchat extends Component{
  state = {
	togglevilla:false,
        villatype:0,
	url: "",
	toggleinfo:false,
	isfpfp:true,
	vnm:'My villa',
        togglemoji:false,
        toggleactinfo:true,
        togglesrvcinfo:true,
        msgallow:0,
        villaid:1,
	vmessg:'',
	villatpid:0,

    };

kevt(e: any){
 	// alert('ok');
        Usersession.setEmojchat(false);

	const ctb = document.getElementById('ctxt') as HTMLInputElement;
        var tx = ctb.value;


       Usersession.setVumsg(tx);
        
  	const btnsend = document.getElementById('btnsendmsgtosrv') as HTMLInputElement;
       if(btnsend) btnsend.click();


        ctb.value = '';
        
        Configdata.ischatscroll = true;

	e.preventDefault();
	
 }

sendchat(txt:any){
const clrcd = Usersession.getColorcode();

const userid = Usersession.getUserId();
//const dvid = localStorage.getItem("dvillaid");
//const vtpid = localStorage.getItem("vilaty");
 const dvid = Usersession.getVillaId();

const vtpid = Usersession.getVillatype();

const objuser = Usersession.getUserpfp();
const pfid = objuser.pfpid;
const utp = objuser.utf;
const name = objuser.uname;
const utpid = objuser.utpid;
//this.savechat(userid,dvid,vtpid,txt,clrcd,pfid,utpid,name,utp);
  
}
savechat(usrid:any,vlaid:any,vtpid:any,tx:any,colorcd:any,pfid:any,utp:any,nm:any,ismf:any){
try {
		//alert(vlaid);
                Usersession.setSubuserstatus(1);

		let url = Configdata.srvurl + '/addchatmsg';
                if(vtpid == 2) url = Configdata.srvurl + '/addchatmsgp';
		//alert(url);	
                const response = axios.post(url, {
    		uid: usrid,
		vid: vlaid,
    		vtd: vtpid,
    		ccod:colorcd,
                msg: tx,
		pfpid:pfid,
		utype:utp,
		uname:nm,
		isf:ismf,
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		
		const usercd = result.data;
                //alert(JSON.stringify(usercd));
		configchat(usercd);
	        });		
              }
		
	   
          }
        catch (e) {
           // debugger;
		  Usersession.setSubuserstatus(0);

        }

}
kevtemoji(e:any){
const emosts = !this.state.togglemoji;
openemoji(emosts);
this.setState({ togglemoji: emosts });
e.preventDefault();

}
kevts(e: any){
 	// alert('ok');

	e.preventDefault();
	
    }
s(e: any){
 	
	e.preventDefault();
	
    }
setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
clrall(){
        showhidediv(true,'chattypedivtop');
 	this.setState({ togglevilla: true });

        showhidediv(true,'chatprofiledivtop');
	this.setState({ toggleinfo: true });
	clrwidgate('wigtarea');
        clrwidgate('Activitylist');
        clrwidgate('Activitynotify');
        clrwidgate('srvcnotify');
        if(cleardv('msgarea')){
	const dv = document.getElementById('msgarea') as HTMLElement;
 	dv.style.display="none";
	}
}
displaychat(e:any){
this.clrall();
 e.preventDefault();

}
setvillatype(e:any){
 const svt = !this.state.togglevilla;
 showhidediv(svt,'chattypedivtop');
 this.setState({ togglevilla: svt });

 e.preventDefault();
}
 setprofile(e:any){
 const svt = !this.state.toggleinfo;
 showhidediv(svt,'chatprofiledivtop');
  this.setState({ toggleinfo: svt });

 //this.showhidevillas(svt);
 e.preventDefault();


}
showprivatevilla(e:any,op:any){
	this.clrall();
        if(op == 1)
	Usersession.setPvtvlsrch(true);

	loadwidgate('wigtarea',2);
	this.showhidevillas(true);
         e.preventDefault();

}

showpublicvilla(e:any){
	this.clrall();
	loadwidgate('wigtarea',1);
	this.showhidevillas(true);
         e.preventDefault();

}
showhidevillas(ishide:any){
	showhidediv(true,'chattypedivtop');
	this.setState({ togglevilla: ishide });
}
showmessage(e:any){
 const userid = Usersession.getUserId();
 pvtmus(userid);
 e.preventDefault();

}


Shoping(e:any){
 	this.clrall();
        Usersession.setIsgifted(0);

	loadwidgate('wigtarea',10);
	this.showhidevillas(true);
         e.preventDefault();

}
getShopitms(e:any){
 	this.clrall();
       
	loadwidgate('wigtarea',12);
	this.showhidevillas(true);
         e.preventDefault();

}

componentDidMount() {
        //debugger;
        this.clrall();
        gtpblvl();
         setdvl();

       const msgalw = Usersession.getMsgallow();

         loadwidgate('vilnm',3);
         this.hangemsgsetdvback();

         if(msgalw == 0) chngbackbyid('allowall','green');
         else if(msgalw == 1) chngbackbyid('allowfrnd','green');
         if(msgalw == 2) chngbackbyid('allownone','green');

           const uservillaid = Usersession.getVillaId();
           this.setState({ villaid: uservillaid});
	   const vtpid = Usersession.getVillatype();
	   //entervilla(uservillaid,
           //const tpid = parseInt(vtpid);

        //   this.setState({ villatpid: tpid});
        //   alert(this.state.villatpid);
	
         setusersinactiondv(uservillaid,false);
    	}
 getfriends(e:any){
         this.clrall();
	 loadwidgate('wigtarea',11);
	 e.preventDefault();

     }	
showactnotify(e:any){
  
  const isshow = !this.state.toggleactinfo;
  
 this.setState({ toggleactinfo: isshow});
 loadwidgate('Activitynotify',13);

  showhidediv(isshow,'Activitynotify');
 
}
showactnotifysrvc(e:any){
  
  const isshow = !this.state.togglesrvcinfo;
  
 this.setState({ togglesrvcinfo: isshow});
 loadwidgate('srvcnotify',14);

  showhidediv(isshow,'srvcnotify');
 
}

 closeact(e:any){
    
	clrwidgate('chactwithptnr');
       showhidediv(true,'chactwithptnr');

   }  
hangemsgsetdvback(){
chngbackbyid('allownone','transparent');
chngbackbyid('allowall','transparent');
chngbackbyid('allowfrnd','transparent');

}  

changebakgroundmsgalow(e:any){
const did = e.target.id;
let msgtp = 0;
if (did == "allowall") msgtp =0;
else if (did == "allowfrnd")  msgtp = 1
else if (did == "allownone") msgtp =  2
this.hangemsgsetdvback();
changeback(e,'green');
this.setState({ msgallow: msgtp });

const apiurl = '/msgeallowsetting';
const uid = Usersession.getUserId();

const obj = {userid:uid,tp:msgtp};
insertpost(apiurl,obj);

}
render() {

return(
     <div>
      <div>
	<div id="cmaindiv"  className="c-outercontainer">

          <div id="cbmaindivtop" className="c-container-top">
            <div id="titletop" className="c-title-top">
             <div id="villamenu" style={{width:'8%'}} className="c-villamenu">
            <a href="#" className="blanka"  onClick={e=>this.setvillatype(e)} title="Villa menu" > 
                   <div id="villaname" className="c-villamenushow">
  
		  	Villa                   
                    </div>
           </a>

		
             </div>
           <div id="notifysrv" style={{width:'8%',backgroundColor:'transparent',marginLeft:'6%'}} className="c-villaname">
        <a href="#" className="blanka"  onClick={e=>this.showactnotifysrvc(e)} title="Service notifications" > 

		 <div id="ntifact" style={{backgroundColor:'transparent'}} className="c-villashow">
		 
		<img src={notifsrv} style={{height:'20px',width:'20px'}} />

             	</div>
         </a>

             </div>

           <div id="notifyact" style={{width:'10%',backgroundColor:'transparent'}} className="c-villaname">
        <a href="#" className="blanka"  onClick={e=>this.showactnotify(e)} title="Action notifications" > 

		 <div id="ntifact" style={{backgroundColor:'transparent'}} className="c-villashow">
		 
		<img src={notif} style={{height:'20px',width:'20px'}} />

             	</div>
         </a>

             </div>

             <div id="villadispaly" className="c-villaname">
        <a href="#" className="blanka"  onClick={e=>this.displaychat(e)} title="villa" > 

		 <div id="vilnm"  className="c-villashow">
		 

             	</div>
         </a>

             </div>
             <div id="pvtmessagemox" style={{width:'8%',backgroundColor:'transparent'}} className="c-villaname">
        <a href="#" className="blanka"  onClick={e=>this.showmessage(e)} title="Message box" > 

		 <div id="pvtmsgbx" style={{backgroundColor:'transparent'}} className="c-villashow">
		 
		<img src={msgbox} style={{height:'20px',width:'20px'}} />

             	</div>
         </a>

             </div>

             <div id="usrmenu" className="c-usermenu">
             <a href="#" className="blanka"  onClick={e=>this.setprofile(e)} title="Profile" > 
			<div id="profileinfo" style={{backgroundColor:'#a15892'}} className="c-usr-profile">
		  	 ||||
             		</div>
	    </a>	
             </div>

	    </div>
            <div id="usrchatarea" className="c-usrchatarea">
              <ReceiverPublicvilla />
	    </div>
	   <div id="usrwidgt" className="cu-frofile-u">

	    </div>

	   </div>	
           <div id="cbmaindiv" className="c-container">
            
	    <Villactions />
          </div>
	    
	 <div>
	     

    </div>
    <div id="chattypedivtop" className="c-room-types">
     <a href="#" className="blanka"  onClick={e=>this.showprivatevilla(e,0)} title="Private villas" > 

    	<div className="c-room-types-menu">Private</div>
    </a>
     <a href="#" className="blanka"  onClick={e=>this.showpublicvilla(e)} title="Public villas" > 

    	<div className="c-room-types-menu">Public</div> 
     </a> 
    <a href="#" className="blanka"  onClick={e=>Exituser()} title="Exit" > 

    	<div className="c-room-types-menu">Exit</div> 
     </a> 

    </div> 
 
    <div id="wigtarea" style={{display:'none',height:'96vh'}} className="c-frofile-info">
     
    </div> 
     <div id="msgarea" style={{display:'none'}} className="c-usermsg-info">
     
    </div>
    <div id="Activitylist" style={{display:'none'}} className="c-usermsg-info">
     
    </div>
    <div id="Activitynotify" style={{display:'none'}} className="c-actnotify-info">
     
    </div>
   <div id="srvcnotify" style={{display:'none'}} className="c-actnotify-info">
     
    </div>
  <div id="Subusdv" style={{display:'none'}} className="subusersarea">
     
    </div>

   <div id="chactwithptnr" style={{zIndex:'33000',display:'none'}} className="useractingarea" >  
		<div style={{height:'auto',width:'100%'}}>  
 	    	<div className="search-title-bar" style={{height:'auto',width:'100%'}}>
                       	<div style={{width:'51%'}} className="search-title">
			  Activities
			</div>
                       
			<a href="#" onClick={e=>this.closeact(e)} title="Activity">
			<div style={{float:'left'}} className="search-title-toggle">
			  X
			</div>
			</a>
	        </div>
		</div>
             <div id="Activityplay" >
		
	     </div>

	 </div>	
 	
    <div id="emojiarea" style={{display:'none'}} className="Emojipic">
     <EmojiPickercomp />
    </div>
     <div id="chatprofiledivtop" style={{height:'97vh'}} className="c-frofile-info">
     
     <div>
        <Userpfp />
     </div>   
    <div>	     
      

      <div style={{backgroundColor:'transparent'}} className="c-info-line">
      <a href="#" className="blanka"  onClick={e=>this.showprivatevilla(e,1)} title="Private villas" > 
       <div className="c-frofile-litem">
	<span className="c-info-cap">Private villas</span><span className="item-count" id="villacounts"></span>

       </div>
      </a>
      </div>  
    <div style={{backgroundColor:'transparent'}} className="c-info-line">
       <div className="c-frofile-litem">
        <a href="#" className="blanka"  onClick={e=>this.getfriends(e)} title="Friends" > 
	<span className="c-info-cap">Friends</span>
        
	</a>
       </div>
      </div>  
     <div style={{backgroundColor:'transparent'}}  className="c-info-line">
       <div className="c-frofile-litem">
        <a href="#" className="blanka"  onClick={e=>this.showmessage(e)} title="message" >
	<span className="c-info-cap">Messages</span>
	</a>
	

       </div>
      </div>  
      <div style={{backgroundColor:'transparent'}} className="c-info-line">
       <a href="#" className="blanka"  onClick={e=>this.Shoping(e)} title="Purchase" > 

       <div className="c-frofile-litem">
	<span className="c-info-cap">Purchase</span>

       </div>
      </a>
      </div>  
      <div style={{backgroundColor:'transparent'}} className="c-info-line">
      <a href="#" className="blanka"  onClick={e=>this.getShopitms(e)} title="Exit" > 
 
       <div className="c-frofile-litem">
	<span className="c-info-cap">Items</span>

       </div>
       </a>
      </div>  
     </div>
      <div id="wgtmsg" className="c-msg-info">
       <div className="per100" style={{display:'table'}}>
                    
 			<div onClick={e=>this.changebakgroundmsgalow(e)} style={{backgroundColor:'transparent'}}>
			 <span id="allowall" className="msgsetmenu"> Allow Every one </span>
			</div>
                      
	 	    
			<div onClick={e=>this.changebakgroundmsgalow(e)} style={{backgroundColor:'transparent'}}>
			 <span id="allowfrnd" className="msgsetmenu"> Allow friends </span>
			</div>
		     
		 
	
 			<div  onClick={e=>this.changebakgroundmsgalow(e)} style={{backgroundColor:'transparent'}}>
			 <span id="allownone" className="msgsetmenu"> Allow NoBody </span>
			</div>

	</div>
      </div>  


    </div>  

     <a href="#" className="blanka"  onClick={e=>this.kevtemoji(e)} title="Emoji" >	
    <div id="btnchatemojidv" className="btnemoji">
	<span className="emospan">e</span>
    </div> 
    </a>
   <a href="#" className="blanka"  onClick={e=>this.kevt(e)} title="Send" >	
    <div id="btnenterchatdv" className="btnentr">
	^
    </div> 
    </a>

  </div>
 
 </div>
</div>
);
}
}